export class MarketPositionPropertyTypes {
  label: string;
  value: number;

  constructor(value: number, label: string) {
    this.value = value;
    this.label = label;
  }
}
